import { useResidentContext } from "app/features/residents/provider/ResidentProvider";
import { FormEnums } from "app/services/api/types/forms/enums/FormEnums";
import { AddIcon } from "ui/gluestack/icon";
import { View } from "react-native";
import { ButtonIcon, ButtonLink, ButtonText } from "ui/gluestack/button";
import { AssessmentHistoryTemplate } from "app/features/reporting/templates/AssessmentHistoryTemplate";
import { PermissionCheck } from "app/features/permission/atoms/PermissionCheck";
import { PermissionsEnums } from "app/services/api/types/authorisation/enums/PermissionsEnums";

export function CarePlanScreen() {
  const { resident } = useResidentContext();

  return (
    <View className="resident-container">
      <PermissionCheck permission={PermissionsEnums.FILL_FORM}>
        <View className="flex-row justify-end mb-4">
          <ButtonLink href={`/residents/${resident?.id}/care-plans/add`}>
            <ButtonIcon as={AddIcon} />
            <ButtonText>New Care Plan</ButtonText>
          </ButtonLink>
        </View>
      </PermissionCheck>
      <AssessmentHistoryTemplate
        tag={FormEnums.CARE_ASSESSMENT}
        residentId={resident?.id}
      />
    </View>
  );
}
